import { createRoot } from "react-dom/client";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";
import { IonReactRouter } from "@ionic/react-router";
import AppNotAvailable from "./components/helpers/AppNotAvailable";
import { IS_DESKTOP_BROWSER } from "./utils/deviceDetectionUtil";
import { AppPrefProvider } from "./components/providers/AppPrefProvider";
import { OrderbookFiltersProvider } from "./components/contexts/OrderbookFiltersContext";

const restrictedHostnames = ["cmedmobile.prod.cmegroup.com"];

const AppGate: React.FC = () => {
  console.log("%%%% IS_DESKTOP_BROWSER", IS_DESKTOP_BROWSER);
  console.log("%%%% hostname:", window.location.hostname);

  const isRestricted =
    restrictedHostnames.includes(window.location.hostname) &&
    IS_DESKTOP_BROWSER;
  console.log("[%%%%App Entry] Is Restricted:", isRestricted);
  return isRestricted ? (
    <AppNotAvailable />
  ) : (
    <AppPrefProvider>
      <OrderbookFiltersProvider>
        <App />
      </OrderbookFiltersProvider>
    </AppPrefProvider>
  );
};

const container = document.getElementById("root");
const root = createRoot(container!);

root.render(<IonReactRouter>{<AppGate />}</IonReactRouter>);

serviceWorkerRegistration.unregister();
reportWebVitals();
